// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"Popup_popupContainer__FOA5V","popup":"Popup_popup__hGDef"};